import { NOTIFICATIONS_LIST } from 'config/constants'

const initialState = {
  data: [],
  isError: false,
  isFetching: false
}

export const ACTION_TYPES = {
  NOTIFICATIONS_REQUEST: 'NOTIFICATIONS_REQUEST',
  NOTIFICATIONS_SUCCESS: 'NOTIFICATIONS_SUCCESS',
  NOTIFICATIONS_ERROR: 'NOTIFICATIONS_ERROR',
  NOTIFICATIONS_UPDATE: 'NOTIFICATIONS_UPDATE',
  NOTIFICATIONS_UPDATE_SUCCESS: 'NOTIFICATIONS_UPDATE_SUCCESS'
}

export const updateNotifications = payload => ({
  type: ACTION_TYPES.NOTIFICATIONS_UPDATE,
  payload
})

export const getNotifications = () => ({
  type: ACTION_TYPES.NOTIFICATIONS_REQUEST
})

const notifications = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.NOTIFICATIONS_REQUEST:
    case ACTION_TYPES.NOTIFICATIONS_UPDATE:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload
      }
    case ACTION_TYPES.NOTIFICATIONS_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      }
    case ACTION_TYPES.NOTIFICATIONS_ERROR:
      return {
        ...state,
        isFetching: false,
        isError: true,
        data: NOTIFICATIONS_LIST.NOTIFICATIONS
      }
    default:
      return { ...state }
  }
}

export default notifications
